import type * as React from 'react';

import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface ChartsTooltipProps {
  title?: React.ReactNode;
  seriesColor?: string;
  children: React.ReactNode;
}

export function ChartsTooltip(props: ChartsTooltipProps) {
  const { children, seriesColor, title } = props;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Paper
      elevation={0}
      sx={{
        // In our theme for tooltips but not a palette color
        backgroundColor: `${isDarkMode ? '#3a6982' : theme.palette.muted[2]}`,
        border: `1px solid ${theme.palette.divider}`,
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.16,
        letterSpacing: '0.03em',
        color: theme.palette.common.white,
      }}
    >
      {title && (
        <Box
          sx={{
            padding: theme.spacing(0.5, 1),
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            {seriesColor && (
              <Box
                sx={{
                  width: 15,
                  height: 15,
                  borderRadius: '50%',
                  backgroundColor: seriesColor,
                  flexShrink: 0,
                }}
              />
            )}
            <Typography
              color={theme.palette.common.white}
              fontSize={14}
              variant="body2"
            >
              {title}
            </Typography>
          </Stack>
        </Box>
      )}
      {children}
    </Paper>
  );
}
